import React from 'react';

import Context from '../../../../../../context';

import {CustomBadges, CustomIcon, TableNullData} from '../../../../../../components';

import './index.sass';
import {locationNamespace} from "../../../../../../types/location.namespace";

type Props = {
  data: any;
};

const Body: React.FC<Props> = ({ data }: Props): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { setSelectedCity, setShowModal } = React.useContext(Context.Location.City);
  const docs = data?.data?.result?.docs;

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function onClickUpdate(city: locationNamespace.city.index): void {
    setSelectedCity!(city);
    setShowModal!('UPDATE');
  }

  function onClickDelete(city: locationNamespace.city.index): void {
    setSelectedCity!(city);
    setShowModal!('DELETE');
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  if (!docs || docs?.length <= 0) return <TableNullData />;
  return (
    <tbody id="location-city-body-wrapper">
      {docs?.map((city: locationNamespace.city.index, index: number) => (
        <tr key={`location-city-tr-${index}`}>
          <td className="table-text">
            {city.name}
          </td>
          <td className="table-text">
            <CustomBadges title={city.province?.name} />
          </td>
          <td className="table-options-wrapper">
            <CustomIcon icon={'fas fa-pencil'         } type='primary' hoverTitle={'ویرایش'} onClick={() => onClickUpdate(city)} />
            <CustomIcon icon={'fas fa-trash-can-xmark'} type='danger'  hoverTitle={'حذف'   } onClick={() => onClickDelete(city)} />
          </td>
        </tr>
      ))}
    </tbody>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default Body;
